import { copyToClipboard } from '@mi-front/core';
import CheckIcon from '@mui/icons-material/Check';
import ShareIcon from '@mui/icons-material/Share';
import { Button, Tooltip } from '@mui/material';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { useTimeoutFn } from 'react-use';

/** Duration in ms to show the success state after copying. */
const SUCCESS_STATE_DURATION_MS = 3000;

/**
 * Copy URL button component that copies the current page URL to clipboard.
 * Shows a disabled state with a check icon for 3 seconds after a successful copy.
 */
export function CopyUrlButton() {
  const { $t } = useIntl();
  const [isSuccess, setIsSuccess] = useState(false);
  const [, , startResetTimer] = useTimeoutFn(
    useCallback(() => setIsSuccess(false), []),
    SUCCESS_STATE_DURATION_MS,
  );

  const handleCopyUrl = () => {
    copyToClipboard(window.location.href);
    setIsSuccess(true);
    startResetTimer();
  };

  return (
    <Tooltip
      enterDelay={100}
      title={
        isSuccess
          ? ''
          : $t({
              id: 'ui.copyUrlButton.copyLink',
              defaultMessage: 'Copiar link para compartir',
            })
      }
    >
      <Button
        size="small"
        variant="outlined"
        color="secondary"
        onClick={handleCopyUrl}
        disabled={isSuccess}
        sx={{ padding: 0, minWidth: '44px' }}
      >
        {isSuccess ? <CheckIcon fontSize="small" /> : <ShareIcon fontSize="small" />}
      </Button>
    </Tooltip>
  );
}
